import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import type { i18n as I18nInstance } from "i18next";
import React, { useEffect } from "react";
import { I18nextProvider, useTranslation } from "react-i18next";
import { appI18n, getI18nLocale } from "./i18n";
import { getAppLocaleConfig, getPickerLocaleText } from "./localeRegistry";

interface AppI18nProviderProps {
    children: React.ReactNode;
    instance?: I18nInstance;
}

const LocaleRuntimeProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const { i18n, t } = useTranslation();
    const locale = getI18nLocale(i18n);
    const config = getAppLocaleConfig(locale);

    useEffect(() => {
        document.documentElement.lang = config.tag;
        document.documentElement.dir = config.direction;
    }, [config.direction, config.tag]);

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={config.dateFnsLocale} localeText={getPickerLocaleText(locale, t)}>
            {children}
        </LocalizationProvider>
    );
};

export const AppI18nProvider: React.FC<AppI18nProviderProps> = ({ children, instance = appI18n }) => {
    return (
        <I18nextProvider i18n={instance}>
            <LocaleRuntimeProvider>{children}</LocaleRuntimeProvider>
        </I18nextProvider>
    );
};

export const useAppLocale = () => {
    const { i18n } = useTranslation();
    return getI18nLocale(i18n);
};
